import { Injectable, InjectionToken } from '@angular/core';
import { SessionService } from 'src/@services/session.service';

export interface AuthTokenProviderPort {
  getAccessToken(): string | null;
  getRefreshToken(): string | null;
  setTokens(accessToken: string, refreshToken: string): void;
}

export const AUTH_TOKEN_PROVIDER = new InjectionToken<AuthTokenProviderPort>(
  'AUTH_TOKEN_PROVIDER'
);

@Injectable({
  providedIn: 'root',
})
export class SessionAuthTokenProviderAdapter implements AuthTokenProviderPort {
  constructor(private sessionService: SessionService) {}

  getAccessToken(): string | null {
    return this.sessionService.getToken();
  }

  getRefreshToken(): string | null {
    return this.sessionService.getLocalStorageItem('RefreshToken');
  }

  setTokens(accessToken: string, refreshToken: string): void {
    this.sessionService.setLocalStorageItem('BearerToken', accessToken);
    this.sessionService.setLocalStorageItem('RefreshToken', refreshToken);
  }
}
